import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import classnames from "classnames";
import withCustomStyles from "./InputPart.style";
import { GField } from "./ui";

// Text input kept for existing forms; renders the redesign GField
// (label above, filled field). Enter blurs the field, as before.
class InputPart extends React.Component {
  handleKeyDown = e => {
    const { onKeyDown } = this.props;
    if (e.key === "Enter") {
      e.target.blur();
    }
    if (typeof onKeyDown === "function") {
      onKeyDown(e);
    }
  };

  render() {
    const {
      props: {
        classes,
        error,
        id,
        label,
        name,
        onChange,
        onClick,
        onFocus,
        value,
        type,
        disabled,
        readOnly,
        helperText,
        placeholder,
        rootClassName,
        inputClassName
      }
    } = this;

    return (
      <GField
        className={classnames(classes.root, rootClassName, inputClassName)}
        id={id !== undefined ? String(id) : undefined}
        name={name}
        label={label}
        type={type || "text"}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        error={error ? helperText || true : undefined}
        help={!error ? helperText : undefined}
        onChange={onChange}
        onClick={onClick}
        onFocus={onFocus}
        onKeyDown={this.handleKeyDown}
      />
    );
  }
}

InputPart.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default withRouter(withCustomStyles(InputPart));
